"use client";

import { useRouter, useSearchParams } from "next/navigation";
/* import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/atoms/accordion"; */
import { Checkbox } from "@/components/atoms/checkbox";
import { Button } from "@/components/atoms/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/atoms/select";
import { Input } from "@/components/atoms/input";
import { useCallback, JSX, useEffect, useState } from "react";
import { X } from "lucide-react";
import Icon from "../FilterIcon";

import Datepicker from "react-tailwindcss-datepicker";

export interface FilterOption {
  type?: "group" | "nested" | "select" | "date" | "checkbox" | "daterange";
  value: string;
  label?: string;
  items?: {
    value: string;
    label?: string;
    items?: { value: string; label?: string }[];
  }[];
}

interface SidebarFilterProps {
  data: FilterOption[];
  isMobile?: boolean;
  onCloseMobile?: () => void;
  onToggleDesktopFilter?: (isVisible: boolean) => void;
}

type DateRangeFilterProps = {
  label?: string;
  value?: string;
};

type FilterChangeCallbackProps = {
  key: string;
  value: string;
  isCheckbox?: boolean;
};

export function SidebarFilter({
  data,
  isMobile,
  onCloseMobile,
  onToggleDesktopFilter,
}: SidebarFilterProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // HOOKS DEVEM VIR ANTES DE QUALQUER FUNÇÃO INTERNA OU RETURN
  const [expandedItems, setExpandedItems] = useState<string[]>(
    data.length > 0 ? [data[0].value] : []
  );
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isDesktopFilterVisible, setIsDesktopFilterVisible] = useState(true);
  // Track grid columns for ofertas list
  const [ofertasGridCols, setOfertasGridCols] = useState(2);

  console.log(ofertasGridCols);

  const getCurrentFilters = (): Record<string, string[]> => {
    const paramsObj: Record<string, string[]> = {};
    if (searchParams) {
      searchParams.forEach((value, key) => {
        paramsObj[key] = value.split("&");
      });
    }
    return paramsObj;
  };

  const currentFilters = getCurrentFilters();

  const scrollToFilterElement = () => {
    const el = document.getElementById("filter-section");
    const elTop = el?.offsetTop;
    window.scrollTo({ top: elTop ? elTop - 100 : 0, behavior: "smooth" });
  };

  const handleFilterChange = useCallback(
    (filters: FilterChangeCallbackProps | FilterChangeCallbackProps[]) => {
      console.log('[FILTER] handleFilterChange chamado com:', filters);
      const params = new URLSearchParams(searchParams || undefined);
      params.delete("page");

      const processFilter = ({
        key,
        value,
        isCheckbox = false,
      }: {
        key: string;
        value: string;
        isCheckbox?: boolean;
      }) => {
        console.log(`[FILTER] Processando filtro - key: ${key}, value: ${value}, isCheckbox: ${isCheckbox}`);
        const existingValues = params.get(key)?.split("&") || [];
        let newValues: string[];

        if (isCheckbox) {
          newValues = existingValues.includes(value)
            ? existingValues.filter((v) => v !== value)
            : [...existingValues, value];
        } else {
          newValues = value.trim() ? [value] : [];
        }

        console.log(`[FILTER] existingValues: ${existingValues}, newValues: ${newValues}`);

        if (newValues.length > 0) {
          params.set(key, newValues.join("&"));
        } else {
          params.delete(key);
        }
      };

      (Array.isArray(filters) ? filters : [filters]).forEach(processFilter);

      // Preserve correct tab for Membros Diretores CEFP when applying related filters
      const isMembrosPage = typeof window !== 'undefined' && (window.location.pathname || '').includes('/membros-conselho');
      const hasCefpFilters = !!(params.get('cms_cefp') || params.get('cms_ilha'));
      if (isMembrosPage && !params.get('tipo') && hasCefpFilters) {
        params.set('tipo', 'diretores_cefp');
      }

      const newUrl = `?${params.toString()}`;
      console.log('[FILTER] Nova URL:', newUrl);

      router.replace(newUrl, {
        scroll: false,
      });

      setTimeout(() => {
        scrollToFilterElement()
        // Add Kevin Sousa => Fecha auto logo ao filtrar em mobile
        if (isMobile && onCloseMobile) {
          onCloseMobile();
        }
      }, 100);
    },
    [router, searchParams, isMobile, onCloseMobile]
  );

  const clearFilters = () => {
    const isMembrosPage = typeof window !== 'undefined' && (window.location.pathname || '').includes('/membros-conselho');
    // On Membros page, keep the Diretores CEFP tab when clearing filters from that context
    if (isMembrosPage) {
      router.replace("?tipo=diretores_cefp");
    } else {
      router.replace("?");
    }
    setTimeout(() => {
      scrollToFilterElement()
    }, 100);
  };

  const hasAnyFilter = searchParams ? Array.from(searchParams.keys()).length > 0 : false;

  const renderers: Record<
    "group" | "nested" | "select" | "date" | "checkbox" | "daterange",
    (item: FilterOption) => JSX.Element | null
  > = {
    group: (item) => (
      <div
        key={item.value}
        className="font-medium text-base text-[#333] mt-4 mb-2"
      >
        {item.label}
      </div>
    ),

    nested: (item) => (
      <div key={item.value} className="border-b border-gray-200">
        <div className="flex justify-between items-center py-3 cursor-pointer"
          onClick={() => {
            const newExpandedItems = expandedItems.includes(item.value)
              ? expandedItems.filter(id => id !== item.value)
              : [...expandedItems, item.value];
            setExpandedItems(newExpandedItems);
          }}>
          <span className="text-base text-[#333]">{item.label}</span>
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`transform transition-transform duration-200 ${expandedItems.includes(item.value) ? 'rotate-180' : ''}`}
          >
            <path
              d="M6 7.4L0.6 2L2 0.6L6 4.6L10 0.6L11.4 2L6 7.4Z"
              fill="#333"
            />
          </svg>
        </div>
        {expandedItems.includes(item.value) && (
          <div className="py-2">
            {item.items?.map((option) => (
              <div key={option.value} className="flex items-center mb-2 ml-2">
                <Checkbox
                  checked={currentFilters[item.value]?.includes(option.value) || false}
                  onCheckedChange={() =>
                    handleFilterChange({
                      key: item.value,
                      value: option.value,
                      isCheckbox: true,
                    })
                  }
                  id={option.value}
                  className="h-4 w-4 border-gray-400"
                />
                <label
                  htmlFor={option.value}
                  className="ml-2 text-sm text-gray-400 cursor-pointer"
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    ),

    select: (item) => (
      <div key={item.value} className="border-b border-gray-200 py-3">
        <div className="flex justify-between items-center cursor-pointer">
          <span className="text-base text-[#333]">{item.label}</span>
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="transform transition-transform duration-200"
          >
            <path
              d="M6 7.4L0.6 2L2 0.6L6 4.6L10 0.6L11.4 2L6 7.4Z"
              fill="#333"
            />
          </svg>
        </div>
        <div className="mt-3">
          <Select
            value={currentFilters[item.value]?.[0] || ""}
            onValueChange={(val: string) =>
              handleFilterChange({
                key: item.value,
                value: val,
              })
            }
          >
            <SelectTrigger className="w-full border-gray-300 bg-white">
              <SelectValue placeholder="Selecione" />
            </SelectTrigger>
            <SelectContent>
              {item.items?.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    ),

    date: (item) => (
      <div key={item.value} className="border-b border-gray-200 py-4">
        <label className="block text-base text-[#333] mb-1">{item.label}</label>
        <div className="relative">
          <Input
            type="date"
            className="w-full border-gray-300 pr-10 focus:ring-2 focus:ring-sky-400 focus:border-sky-400 rounded-md py-2"
            value={currentFilters[item.value]?.[0] || ""}
            onChange={(e) =>
              handleFilterChange({
                key: item.value,
                value: e.target.value,
              })
            }
            placeholder="Selecione a data"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path stroke="#9E9E9E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M8 2v2m8-2v2M3 8h18M5 8v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8M5 8h14" /></svg>
          </span>
        </div>
      </div>
    ),

    checkbox: (item) => (
      <div key={item.value} className="border-b border-gray-200 py-3">
        <div className="flex justify-between items-center cursor-pointer">
          <span className="text-base text-[#333]">{item.label}</span>
        </div>
        <div className="mt-3 space-y-2">
          {item.items?.map((option) => (
            <div key={option.value} className="flex items-center">
              <Checkbox
                checked={currentFilters[item.value]?.includes(option.value) || false}
                onCheckedChange={() =>
                  handleFilterChange({
                    key: item.value,
                    value: option.value,
                    isCheckbox: true,
                  })
                }
                id={option.value}
                className="h-4 w-4 border-gray-400"
              />
              <label
                htmlFor={option.value}
                className="ml-2 text-sm text-gray-600 cursor-pointer"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    ),
    daterange: (item) => {
      const startSettings: DateRangeFilterProps = item.items?.[0] ?? {};
      const endSettings: DateRangeFilterProps = item.items?.[1] ?? {};

      if (!(startSettings?.value && endSettings?.value)) return null;

      const start = currentFilters[startSettings.value]?.[0] || "";
      const end = currentFilters[endSettings.value]?.[0] || "";

      return (
        <div key={item.value} className="border-b border-gray-200 py-3">
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => {
              const newExpandedItems = expandedItems.includes(item.value)
                ? expandedItems.filter(id => id !== item.value)
                : [...expandedItems, item.value];
              setExpandedItems(newExpandedItems);
            }}
          >
            <span className="text-base text-[#333]">{item.label}</span>
            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`transform transition-transform duration-200 ${expandedItems.includes(item.value) ? 'rotate-180' : ''}`}
            >
              <path
                d="M6 7.4L0.6 2L2 0.6L6 4.6L10 0.6L11.4 2L6 7.4Z"
                fill="#333"
              />
            </svg>
          </div>
          {expandedItems.includes(item.value) && (
            <div className="mt-3 space-y-3">
              <div>
                <label className="text-sm text-gray-600 block mb-1">{startSettings.label || "Início"}</label>
                <Datepicker
                  i18n="pt"
                  asSingle={true}
                  containerClassName="relative w-full"
                  inputClassName="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-sky-400 focus:border-sky-400 focus:outline-none"
                  toggleClassName="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  displayFormat="DD/MM/YYYY"
                  placeholder="Data de Início"
                  useRange={false}
                  value={{
                    startDate: start ? new Date(start) : null,
                    endDate: start ? new Date(start) : null,
                  }}
                  onChange={(v) => {
                    const newStart = v?.startDate ?? null;
                    handleFilterChange({
                      key: startSettings.value ?? "",
                      value: formatDateToString(newStart),
                    });
                  }}
                />
              </div>
              <div>
                <label className="text-sm text-gray-600 block mb-1">{endSettings.label || "Fim"}</label>
                <Datepicker
                  i18n="pt"
                  asSingle={true}
                  containerClassName="relative w-full"
                  inputClassName="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-sky-400 focus:border-sky-400 focus:outline-none"
                  toggleClassName="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  displayFormat="DD/MM/YYYY"
                  placeholder="Data de Fim"
                  useRange={false}
                  value={{
                    startDate: end ? new Date(end) : null,
                    endDate: end ? new Date(end) : null,
                  }}
                  onChange={(v) => {
                    const newEnd = v?.startDate ?? null;
                    handleFilterChange({
                      key: endSettings.value ?? "",
                      value: formatDateToString(newEnd),
                    });
                  }}
                />
              </div>
            </div>
          )}
        </div>
      );
    },
  };

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [isMobile]);

  if (isMobile) {
    return (
      <div id="filter-section" className="w-full h-full flex flex-col p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="font-medium text-lg text-[#333]">
            Filtros
          </h2>

          {hasAnyFilter && (
            <Button
              variant="outline"
              className="flex items-center gap-1 text-[#333] text-sm border-gray-300 px-2 py-1 h-8"
              onClick={clearFilters}
            >
              <X className="h-3 w-3" />
              Limpar
            </Button>
          )}

          {isMobile && (
            <Button
              variant="outline"
              className="flex items-center gap-1 text-[#333] text-sm border-gray-300 px-2 py-1 h-8"
              onClick={onCloseMobile}
            >
              <X className="h-3 w-3" />
              Fechar
            </Button>
          )}
        </div>

        {/* Conteúdo dos filtros no mobile */}
        <div className="space-y-4 flex-1 overflow-y-auto">
          {data.map((item) => {
            const safeType = item.type ?? "nested";
            return renderers[safeType]?.(item);
          })}
        </div>
      </div>
    );
  }

  const handleOpenFilter = () => {
    setIsFilterOpen(true);
  };

  const handleCloseFilter = () => {
    setIsFilterOpen(false);
  };

  const handleToggleDesktopFilter = () => {
    const newVisibility = !isDesktopFilterVisible;
    setIsDesktopFilterVisible(newVisibility);
    // Change ofertas grid columns when toggling filter
    setOfertasGridCols(newVisibility ? 2 : 3);
    onToggleDesktopFilter?.(newVisibility);
  };

  return (
    <div id="filter-section" className="mt-1 mb-20">
      <div className="mt-0 mb-16">
        <button
          onClick={isMobile ? handleOpenFilter : handleToggleDesktopFilter}
          className="flex justify-center items-center"
          title={isMobile ? "Abrir filtros" : (isDesktopFilterVisible ? "Esconder filtros" : "Mostrar filtros")}
        >
          <Icon />
        </button>
      </div>

      {/* Mobile filter overlay */}
      {isFilterOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center lg:hidden">
          <div className="bg-white w-[90%] max-w-md h-[90%] max-h-[600px] rounded-lg p-4 overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-medium text-lg text-[#333]">Filtros</h2>
              <button onClick={handleCloseFilter} className="text-gray-500">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="space-y-4">
              {data.map((item) => {
                const safeType = item.type ?? "nested";
                return renderers[safeType]?.(item);
              })}
            </div>
          </div>
        </div>
      )}

      {/* Ofertas grid example usage: pass ofertasGridCols to ofertas list/grid component */}
      {/* <OfertasList gridCols={ofertasGridCols} /> */}

      <div className="hidden lg:block">
        {isDesktopFilterVisible && (
          <div className="md:w-[200px] lg:w-[280px] h-auto">
            {data.map((item) => {
              const safeType = item.type ?? "nested";
              return renderers[safeType]?.(item);
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// function normalizeDate(date: Date): Date {
//   // Remove the +1 day addition that was causing date offset issues
//   return new Date(date);
// }

function formatDateToString(date: Date | null): string {
  return date ? date.toISOString().split("T")[0] : ""; // Extract "yyyy-MM-dd"
}
